module.exports = __webpack_public_path__ + "9f2d22b905de6405bca2f3e9e9e1241e.pdf";